import { createClient } from '@supabase/supabase-js'

const supabaseUrl = (import.meta as any).env.VITE_SUPABASE_URL
const supabaseAnonKey = (import.meta as any).env.VITE_SUPABASE_ANON_KEY

// Check if environment variables are configured
const isSupabaseConfigured = supabaseUrl && 
  supabaseAnonKey && 
  supabaseUrl !== 'https://your-project-id.supabase.co' && 
  supabaseAnonKey !== 'your-anon-key-here'

if (!isSupabaseConfigured) {
  console.warn('⚠️  Supabase is not configured. Please set up your environment variables.')
  console.warn('📝 Copy env.example to .env and add your Supabase credentials.')
  console.warn('🔗 Get your credentials from: https://app.supabase.com')
}

// Create a dummy client if not configured to prevent app crashes
export const supabase = isSupabaseConfigured 
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true
      }
    })
  : null

// Database types for TypeScript
export interface Database {
  public: {
    Tables: {
      profiles: {
        Row: {
          id: string
          first_name: string
          last_name: string
          email: string
          created_at: string
          updated_at: string
          subscription_status: 'freemium' | 'professional' | 'studio' | null
          subscription_id: string | null
        }
        Insert: {
          id: string
          first_name: string
          last_name: string
          email: string
          created_at?: string
          updated_at?: string
          subscription_status?: 'freemium' | 'professional' | 'studio' | null
          subscription_id?: string | null
        }
        Update: {
          id?: string
          first_name?: string
          last_name?: string
          email?: string
          created_at?: string
          updated_at?: string
          subscription_status?: 'freemium' | 'professional' | 'studio' | null
          subscription_id?: string | null
        }
      }
      clients: {
        Row: {
          id: string
          name: string
          email: string
          phone: string | null
          company: string | null
          notes: string | null
          created_at: string
          updated_at: string
          user_id: string
        }
        Insert: {
          id?: string
          name: string
          email: string
          phone?: string | null
          company?: string | null
          notes?: string | null
          created_at?: string
          updated_at?: string
          user_id: string
        }
        Update: {
          id?: string
          name?: string
          email?: string
          phone?: string | null
          company?: string | null
          notes?: string | null
          created_at?: string
          updated_at?: string
          user_id?: string
        }
      }
      shoots: {
        Row: {
          id: string
          title: string
          type: 'photo' | 'video'
          client_id: string
          date: string
          start_time: string
          end_time: string
          location: string | null
          notes: string | null
          status: 'scheduled' | 'in_progress' | 'completed' | 'cancelled'
          created_at: string
          updated_at: string
          user_id: string
        }
        Insert: {
          id?: string
          title: string
          type: 'photo' | 'video'
          client_id: string
          date: string
          start_time: string
          end_time: string
          location?: string | null
          notes?: string | null
          status?: 'scheduled' | 'in_progress' | 'completed' | 'cancelled'
          created_at?: string
          updated_at?: string
          user_id: string
        }
        Update: {
          id?: string
          title?: string
          type?: 'photo' | 'video'
          client_id?: string
          date?: string
          start_time?: string
          end_time?: string
          location?: string | null
          notes?: string | null
          status?: 'scheduled' | 'in_progress' | 'completed' | 'cancelled'
          created_at?: string
          updated_at?: string
          user_id?: string
        }
      }
    }
  }
} 